<script>


import StaticMap from './StaticMap.svelte';
import RepTablePrint from './RepTablePrint.svelte';
import { staticMapURLsDict } from '../../stores';
import {__} from '../../utils/i18n';

/**
 * @type {string}
 */
export let level; 
export let reps;
export let headers;
export let heading;

/**
 * @type {any[]}
 */
export let name; 
/**
 * @type {boolean}
 */


let xwalk= {
  "city": "city",
  "county": "supervisors",
  "congressional": "congressional"
}


</script>

<section hidden class="{level} print"> 
  <h3 class="header">
    {level == "city" ? "Local" : __(level) }
  </h3>
  <div class="columns">
    {#if level == "state"}   
      <div class="map-wrapper" ><img class="static-map" id="stateMap"></div>
    {:else}
      <StaticMap
        url={$staticMapURLsDict[`${xwalk[level]}`]}
        altText={name !== 'Unincorporated'
          ? __('Map with the city of ') + name + __(' outlined.')
          : __('Map of unincorporated areas in Los Angeles County outlined.')}
        lazyLoad="false"
      />
    {/if}
    <div class="table-wrapper">
      {@html heading}
      <RepTablePrint {reps} {headers}/>
    </div>
  </div>
</section>